export enum Locale {
  En = 'en',
  EnDate = 'en-only-date',
}
